import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'pratica';

const getApi = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "api" , data: params}, callback);
const getAtti = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_atti"}, callback);
const saveFiles = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "save_files", data: params}, callback);
const deleteFile = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "delete_file", data: params}, callback);
const caricamentoDocCompletato = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "caricamento_doc_completato", data: params}, callback);
const updateDocumenti = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "update_documenti", data: params}, callback);
const creaAggiornaPratica = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "process" , data: params}, callback);
const upsertNotePratica = (settings, params, callback) => generateRequest('note_pratica', settings, {action: "process" , data: params}, callback);

const apiEndpoint = {
  getApi,
  getAtti,
  saveFiles,
  deleteFile,
  caricamentoDocCompletato,
  creaAggiornaPratica,
  upsertNotePratica,
  updateDocumenti
}

export default apiEndpoint;